/**
 * Función helper para hacer scroll suave a una sección
 * Tiene en cuenta el navbar fijo con un offset
 */
export const scrollToSection = (sectionId: string, offset: number = 100) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

/**
 * Función específica para scroll a servicios
 */
export const scrollToServicios = () => {
  scrollToSection('servicios');
};

/**
 * Función específica para scroll a eventos
 */
export const scrollToEventos = () => {
  scrollToSection('eventos');
};

